import React from "react";
import { useParams } from "react-router-dom";
import ReactPlayer from "react-player";
import useFetch from "../../../hooks/useFetch";

const FunctionHeader = ({ headerName }) => {
  return (
    <>
      <div>
        <div className="w-44 text-2xl font-semibold py-3 px-2">{headerName}</div>
        <div className="w-64 h-[3px] bg-gradient-to-r from-blue-900 to-blue-100" />
      </div>
    </>
  )
}

const ListItem = ({ List }) => {

  return (
    <div className="mt-3">
      {
        List && List.map((list, index) => {
          const {
            header, nextItems
          } = list
          return <Items key={index} id={index + 1} header={header} nextItems={nextItems} />
        })
      }
    </div>
  )
}

const Items = ({ id, header, nextItems }) => {
  return (
    <div className="pl-6 leading-7 my-2">
      <div className="text-xl font-semibold">{`${id}) ${header}`}</div>
      {
        Array.isArray(nextItems) ? (
          <ul>
            {
              nextItems && nextItems.map((next, index) => {
                return <li key={index} className="pl-4 text-xl my-2">{next}</li>
              })
            }
          </ul>
        ) : (
          <p className="pl-4 text-xl my-2">{nextItems}</p>
        )
      }
    </div>
  )
}


const Item = ({ pictureList, anotherInfo, videoList }) => {

  const [
    {
      applicationVos,
      header,
      headerDesc,
      productCenterFeatureVos,
      productCenterModuleVos,
      softwareEnvVos
    }
  ] = anotherInfo

  return (
    <div className="flex w-[1200px] flex-col justify-center bg-slate-100 rounded-md my-[200px] px-24">
      <div className="flex flex-col justify-center items-center gap-y-3">
        <p className="text-3xl font-semibold mt-12">{header}</p>
        <p className="text-2xl mt-6 indent-12">{headerDesc}</p>
      </div>
      <div className="w-full h-[3px] mt-4 bg-gradient-to-r from-blue-900 to-blue-300" />
      <div className="pt-6">
        <div className="font-bold text-2xl mb-2 bg-blue-900 w-44 flex justify-center items-center py-3 rounded-full text-white px-6">产品概述</div>
        <div>
          <FunctionHeader headerName={'功能模块'} />
          <ul className="my-3 grid grid-rows-2 grid-cols-2 pl-6 gap-6">
            {
              productCenterModuleVos.map((module, index) => {
                const { moduleName } = module
                return <li key={index} className="text-xl font-semibold my-2 bg-cyan-500 pl-4 rounded-md py-4">{moduleName}</li>
              })
            }
          </ul>
        </div>
        <FunctionHeader headerName={'应用功能'} />
        <ListItem List={applicationVos.map((item) => {
          const {
            appContent,
            appHeader
          } = item
          return {
            header: appHeader,
            nextItems: appContent
          }
        })} />
        <FunctionHeader headerName={'软件环境'} />
        <ListItem List={softwareEnvVos.map((item) => {
          const {
            softwareContent,
            softwareHeader
          } = item
          return {
            header: softwareHeader,
            nextItems: softwareContent
          }
        })} />
        <FunctionHeader headerName={'特点'} />
        <ListItem List={productCenterFeatureVos.map((item) => {
          const {
            featureContent,
            featureHeader
          } = item
          return {
            header: featureHeader,
            nextItems: featureContent
          }
        })} />
      </div>
      <div className="my-6 rounded-l-md px-8">
        <ul className="flex flex-col gap-y-5 items-center">
          {
            pictureList.map((item, idx) => {
              return <li key={idx}>
                <img
                  src={item}
                />
              </li>
            })
          }
        </ul>
      </div>
      <div className="my-6 flex justify-center">
        {
          videoList.map((item, idx) => {
            return <ReactPlayer
              key={idx}
              controls
              width={1200}
              height={600}
              url={item}
            />
          })
        }
      </div>
    </div>
  )
}

const SecondProduct = () => {
  const { itemId } = useParams();
  const responseData = useFetch(`http://1.94.62.64:9090/myf/products/${itemId}/detail`)

  const {
    pictureList = [],
    videoList = [],
    id = null,
    ...restInfo
  } = responseData ?? {}

  const arr = [{
    pictureList,
    videoList,
    id,
    anotherInfo: [
      restInfo ? {
        ...restInfo
      } : {}
    ]
  }]

  return (
    <div className="flex items-center justify-center">
      {responseData && arr.map((item) => {
        return (
          <Item
            key={item.id}
            pictureList={item.pictureList}
            anotherInfo={item.anotherInfo}
            videoList={item.videoList}
          />
        )
      })}
    </div>
  );
};

export default SecondProduct;
